import React, {
    useState,
    useEffect,
} from 'react';

import { getBasketData } from "../queries/global"
import BasketSummary from '../components/basket-summary';
import LoadingIndicator from './loading-indicator';
import ChevronIcon from '../svg/chevron'

import * as UTILS from "../utils/utils";
import config from "../config/config";

const is_disclosure = window.matchMedia("(max-width: 48em)").matches;

export default function OrderSummary(props) {

    const [disclosureOpen, setDisclosureOpen] = useState(false);
    const [groupedTickets, setGroupedTickets] = useState(null);
    const [total, setTotal] = useState(null);

    const { data: basketData, isFetching } = getBasketData();

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        let tickets = basketData.tickets;
        let tickets_total = basketData.total;

        const grouped_tickets = UTILS.groupTicketsByInstance(tickets);
        
        setGroupedTickets(grouped_tickets);
        setTotal(tickets_total.toFixed(2))

    }, [basketData]);

    return (
        <>
        {is_disclosure &&
            <button type="button" 
                    className='btn order-summary__disclosure-button' 
                    onClick={() => setDisclosureOpen(!disclosureOpen)} 
                    aria-expanded={disclosureOpen} 
                    aria-controls="orderSummary">
                        Order summary
                        <ChevronIcon />
            </button>
        }
        <div id="orderSummary" className="order-summary" {...(is_disclosure ? {hidden: !disclosureOpen, "aria-hidden": !disclosureOpen} : {})}>
            {groupedTickets?.length ? 
                <>
                    <h2 className="booking-pathway__header">Order summary</h2>
                    <ul className="order-summary__list" role="list">
                        {groupedTickets.map((group) => (
                            <li key={group.instance_id}>
                                <div className='instance-event-summary'>
                                    <p className="instance-event-summary__title">{group.event_name}</p>
                                    <p className="instance-event-summary__date">{ group.instance_date }</p>
                                    <p className="instance-event-summary__venue">{ group.event_venue }</p>
                                </div>
                                <p className="order-summary__item">
                                    <span>{`x${group.tickets.length} ticket`}</span>
                                    <span>{`£${group.tickets_total.toFixed(2)}`}</span>
                                </p>
                            </li>
                        ))}
                    </ul>

                    <BasketSummary />
                </>
            : null}

            {is_disclosure &&
                <button type="button" 
                        className='btn order-summary__disclosure-button--hide' 
                        onClick={() => setDisclosureOpen(!disclosureOpen)} 
                        aria-expanded={disclosureOpen} 
                        aria-controls="orderSummary">
                            Hide summary
                </button>
            }
        </div>
        </>
    );
}